import React from "react";

export default function Card32BRules() {
  return (
    <div className="modal-body">
      <div>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '\n        .rules-section .row.row5 {\n            margin-left: -5px;\n            margin-right: -5px;\n        }\n        .rules-section .pl-2 {\n            padding-left: .5rem !important;\n        }\n        .rules-section .pr-2 {\n            padding-right: .5rem !important;\n        }\n        .rules-section .row.row5 > [class*="col-"], .rules-section .row.row5 > [class*="col"] {\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n        .rules-section\n        {\n            text-align: left;\n            margin-bottom: 10px;\n        }\n        .rules-section .table\n        {\n            color: #fff;\n            border:1px solid #444;\n            background-color: #222;\n            font-size: 12px;\n        }\n        .rules-section .table td, .rules-section .table th\n        {\n            border-bottom: 1px solid #444;\n            border-right: 1px solid #444;\n            vertical-align: middle;\n            text-align: center;\n        }\n        .rules-section ul li, .rules-section p\n        {\n            margin-bottom: 5px;\n        }\n        .rules-section::-webkit-scrollbar {\n            width: 8px;\n        }\n        .rules-section::-webkit-scrollbar-track {\n            background: #666666;\n        }\n\n        .rules-section::-webkit-scrollbar-thumb {\n            background-color: #333333;\n        }\n        .rules-section .rules-highlight\n        {\n            color: #FDCF13;\n            font-size: 16px;\n        }\n        .rules-section .rules-sub-highlight {\n            color: #FDCF13;\n            font-size: 14px;\n        }\n        .rules-section .list-style, .rules-section .list-style li\n        {\n            list-style: disc;\n        }\n        .rules-section .rule-card\n        {\n            height: 20px;\n            margin-left: 5px;\n        }\n        .rules-section .card-character\n        {\n            font-family: Card Characters;\n        }\n        .rules-section .red-card\n        {\n            color: red;\n        }\n        .rules-section .black-card\n        {\n            color: black;\n        }\n        .rules-section .cards-box\n        {\n            background: #fff;\n            padding: 6px;\n            display: inline-block;\n            color: #000;\n            min-width: 150px;\n        }\n        .rules-section .casino-tabs {\n            background-color: #222 !important;\n            border-radius: 0;\n        }\n        .rules-section .casino-tabs .nav-tabs .nav-link\n        {\n            color: #fff !important;\n        }\n        .rules-section .casino-tabs .nav-tabs .nav-link.active\n        {\n            color: #FDCF13 !important;\n            border-bottom: 3px solid #FDCF13 !important;\n        }\n    ',
          }}
        />
        <div className="rules-section">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Cards Deck</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>6(SPADE) 6(HEART) 6(CLUB) 6(DIAMOND)</td>
                  <td>6 POINT</td>
                </tr>
                <tr>
                  <td>7(SPADE) 7(HEART) 7(CLUB) 7(DIAMOND)</td>
                  <td>7 POINT</td>
                </tr>
                <tr>
                  <td>8(SPADE) 8(HEART) 8(CLUB) 8(DIAMOND)</td>
                  <td>8 POINT</td>
                </tr>
                <tr>
                  <td>9(SPADE) 9(HEART) 9(CLUB) 9(DIAMOND)</td>
                  <td>9 POINT</td>
                </tr>
                <tr>
                  <td>10(SPADE) 10(HEART) 10(CLUB) 10(DIAMOND)</td>
                  <td>10 POINT</td>
                </tr>
                <tr>
                  <td>J(SPADE) J(HEART) J(CLUB) J(DIAMOND)</td>
                  <td>11 POINT</td>
                </tr>
                <tr>
                  <td>Q(SPADE) Q(HEART) Q(CLUB) Q(DIAMOND)</td>
                  <td>12 POINT</td>
                </tr>
                <tr>
                  <td>K(SPADE) K(HEART) K(CLUB) K(DIAMOND)</td>
                  <td>13 POINT</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ul className="pl-4 pr-4 list-style">
            <li>
              This is a value card game &amp; Winning result will count on
              Highest cards total.
            </li>
            <li>
              There are total 4 players, every player have default prefix
              points. Default points will be consider as following table.
            </li>
          </ul>
          <h6 className="rules-highlight">Playing Game Rules:</h6>
          <div className="table-responsive">
            <table className="table">
              <tbody>
                <tr>
                  <td>
                    <div>
                      <b>PLAYER 8</b>
                    </div>
                    <div>8 Point</div>
                  </td>
                  <td>
                    <div>
                      <b>PLAYER 9</b>
                    </div>
                    <div>9 Point</div>
                  </td>
                  <td>
                    <div>
                      <b>PLAYER 10</b>
                    </div>
                    <div>10 Point</div>
                  </td>
                  <td>
                    <div>
                      <b>PLAYER 11</b>
                    </div>
                    <div>11 Point</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ul className="pl-4 pr-4 list-style">
            <li>
              In game, every player has to count sum of default points and their
              ownopened card's point.
            </li>
            <li>
              If in first level, the sum is same with more than one player, then
              thatwill be tie and winner tied players go for next level.
            </li>
            <li>
              This sum will go and go upto Single Player Highest Sum of Point.
            </li>
            <li>At last Highest Point Cards's Player declare as a Winner.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
